import { Box, Center, LoadingOverlay, Tooltip, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconFileOff } from '@tabler/icons-react';
import useFileDownload from 'api/use-file-download';
import FileThumbnail from 'components/files/FileThumbnail';
import Slider from 'components/modals/slider/Slider';
import { PriceOfferRow } from 'components/tables/data/price-offer/types';

/**
 * Column for the price offer file preview.
 */
export default function FileColumn({ data }: { data: PriceOfferRow }) {
  const theme = useMantineTheme();
  const [sliderOpened, { open: openSlider, close: closeSlider }] = useDisclosure(false);
  const { loading, download } = useFileDownload();
  const { fileId } = data;

  if (!fileId) {
    return (
      <Tooltip label="Súbor nie je priložený">
        <Center w={52} h={52}>
          <IconFileOff size={24} stroke={1.5} color={theme.colors.gray[4]} />
        </Center>
      </Tooltip>
    );
  }

  return (
    <Box pos="relative" w={52} h={52} miw={52} mih={52} mah={52} maw={52}>
      <LoadingOverlay visible={loading} loaderProps={{ size: 'xs' }} />
      <FileThumbnail fileId={fileId} onOpenSlider={openSlider} onUnsupportedPreviewClick={() => download(fileId)} />
      <Slider opened={sliderOpened} fileIds={[fileId]} onClose={closeSlider} initialImageId={fileId} />
    </Box>
  );
}
